import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import NonlalinDisposisi from "../../../utilities/nonlalin/NonlalinDisposisi";
import { FaMagnifyingGlass } from "react-icons/fa6";
import NonlalinService from "../../../services/nonlalin/NonlalinService";
import { formatDateString, formatDateTimeLocalDateOnly } from "../../../utilities/Utils";
import UploadService from "../../../services/transaksi/UploadService";
import SweetAlert from "react-bootstrap-sweetalert";

const ModalSppScanning = ({ showAddSppScanning, handleCloseAddSppScanning, dataDisposisi, datappm, reloadList, isEdit }) => {

    let nonlalinService = useMemo(() => new NonlalinService(), [])
    let uploadService = useMemo(() => new UploadService(), [])

    const [dataSpp, setDataSpp] = useState(null)

    const [noTugas, setNoTugas] = useState(null)
    const [tglTugas, setTglTugas] = useState(null)
    const [filePath, setFilePath] = useState(null)
    const [fileNameOri, setFileNameOri] = useState(null)
    const [valueFile, setValueFile] = useState(null)

    const onChangeNoTugas = e => {
        setNoTugas(e.target.value)
    }

    const onChangeTglTugas = e => {
        setTglTugas(e.target.value)
    }

    const handleUploadFile = e => {
        e.preventDefault()
        // console.log(e)
        const file = e.target.files[0];
        // console.log(file)
        if (file) {
            if (file.type !== "application/pdf") {
                alert("Only PDF files are allowed.");
                return;
            }

            const newFileName = file.name.replaceAll(" ", "-").replace(".pdf", '_' + formatDateTimeLocalDateOnly(new Date()) + ".pdf")
            const renamedFile = new File([file], newFileName, {
                type: file.type
            })
            setFileNameOri(renamedFile.name)
            setValueFile(renamedFile)
            setFilePath(process.env.REACT_APP_API_URL_FILE + '/view/' + datappm.nomorAju + '/' + renamedFile.name)

        }
    }

    const fetchAllData = useCallback(async () => {
        if (!datappm.nomorAju || !dataDisposisi.noTugas) {
            return
        }
        try {
            const resScanSampleTugas = await nonlalinService.getScanSampleTugas(datappm.nomorAju, '1', dataDisposisi.noTugas)
            setDataSpp(resScanSampleTugas.data)
            setNoTugas(resScanSampleTugas?.data?.noTugas)
            setTglTugas(resScanSampleTugas?.data?.tglTugas)
            setFilePath(resScanSampleTugas?.data?.filePath)
            setFileNameOri(resScanSampleTugas?.data?.fileNameOri)
        } catch (error) {
            setDataSpp(null)
        }

    }, [dataDisposisi, datappm, nonlalinService])

    useEffect(() => {
        let isMounted = true;
        if (!datappm) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [datappm, fetchAllData]);

    const [base64String, setBase64String] = useState(null)
    const [showOpenPreview, setShowOpenPreview] = useState(false)
    const handleClickPreview = async (dokPath) => {
        setBase64String(dokPath)
        setShowOpenPreview(true)
    }
    const handleClosePreview = () => {
        setBase64String(null)
        setShowOpenPreview(false)
    }

    const [kelengkapan, setKelengkapan] = useState({})
    const checkKelengkapan = () => {
        const checkKelengkapan = {}

        if (!noTugas) checkKelengkapan.noTugas = 'Nomor ST Wajib Diisi'
        if (!tglTugas) checkKelengkapan.tglTugas = 'Tanggal ST Wajib Diisi'
        if (!valueFile) checkKelengkapan.file = 'File Wajib Diunggah'

        setKelengkapan(checkKelengkapan)
        return Object.keys(checkKelengkapan).length === 0
    }

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmSave, setShowConfirmSave] = useState(false)
    const handleCloseConfirmSave = () => setShowConfirmSave(false)
    const handleShowConfirmSave = () => setShowConfirmSave(true)

    const [showSaveSuccess, setShowSaveSucces] = useState(false)
    const [showSaveFailed, setShowSaveFailed] = useState(false)

    const handleClickSimpan = async () => {
        if (checkKelengkapan()) {
            try {
                // let dataheader = JSON.parse(localStorage.getItem('dataHeaderStorage'))
                setLoadingSave(true)
                let jsonSppScan = {
                    ...dataSpp,
                    nomorAju: datappm.nomorAju,
                    jenisSurat: '1',
                    noTugas: noTugas,
                    tglTugas: tglTugas,
                    filePath: filePath,
                    fileNameOri: fileNameOri,
                    createdDate: new Date(),
                    createdBy: localStorage.getItem('userId')
                }
                // console.log(jsonDataDokumen)
                const response = await nonlalinService.saveScanSampleTugas(jsonSppScan)
                if (response.data.kode === '200') {
                    const resUpload = await uploadService.uploadFile(datappm.nomorAju, valueFile)
                    // console.log(resUpload)
                    if (resUpload.status === 200) {
                        setShowSaveSucces(true)
                        setShowConfirmSave(false)

                        let dataDispo = {
                            ...dataDisposisi,
                            noTugas: noTugas,
                            tglTugas: tglTugas,
                            createdBy: localStorage.getItem('userId'),
                            createdAt: new Date()
                        }
                        await nonlalinService.saveNonlalinPenugasan(dataDispo)

                        let dataLHScan = { idDisposisi: 18, nomorAju: datappm.nomorAju }
                        await nonlalinService.saveNonlalinPenugasan(dataLHScan)

                        let dataPpm = { ...datappm, status: '032' }
                        await nonlalinService.saveNonlalinHeader(dataPpm)

                        let jsonStatus = {
                            nomorAju: datappm.nomorAju,
                            kodeStatus: '030',
                            waktuStatus: new Date(),
                            createdBy: localStorage.getItem('username')
                        }
                        await nonlalinService.saveNonlalinStatus(jsonStatus)
                    }
                }
                setLoadingSave(false)
            } catch (error) {
                setShowConfirmSave(false)
                setShowSaveFailed(true)
                setLoadingSave(false)
                // console.log(error)
            }
        } else {
            setShowConfirmSave(false)
            setShowSaveFailed(true)
        }
    }

    const handleClickSaveSuccess = () => {
        setShowSaveSucces(false)
        reloadList(datappm.nomorAju)
        resetField()
        handleCloseAddSppScanning()
    }

    const handleClickSaveFailed = () => {
        resetField()
        handleCloseAddSppScanning()
        setShowSaveFailed(false)
    }

    const handleClickBatal = () => {
        resetField()
        handleCloseAddSppScanning()
    }

    const resetField = () => {
        setNoTugas(null)
        setTglTugas(null)
        setFilePath(null)
        setFileNameOri(null)
        setValueFile(null)
    }

    return (
        <>
            <Modal
                show={showAddSppScanning}
                onHide={handleCloseAddSppScanning}
                size="lg"
                centered
                backdrop='static'
            >
                <Modal.Header><h6><NonlalinDisposisi idDisposisi={dataDisposisi.idDisposisi} /></h6></Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Nomor Aju" className="form-control-sm" value={datappm?.nomorAju} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor <span className="text-danger">*</span></Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="Nomor ST Scanning" className="form-control-sm" value={noTugas} onChange={onChangeNoTugas} />
                                    </Col>
                                </Form.Group>
                            </Form>
                            {kelengkapan.noTugas && <div className='text-danger'>{kelengkapan.noTugas}</div>}
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal <span className="text-danger">*</span></Form.Label>
                                    <Col sm="3">
                                        <Form.Control type="date" className="form-control-sm" value={tglTugas ? formatDateString(tglTugas) : null} onChange={onChangeTglTugas} />
                                    </Col>
                                </Form.Group>
                            </Form>
                            {kelengkapan.tglTugas && <div className='text-danger'>{kelengkapan.tglTugas}</div>}
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Upload ST Scanning <span className="text-danger">*</span> (max 1 Mb)</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="file" className="form-control-sm" accept='application/pdf' onChange={e => handleUploadFile(e)} />
                                    </Col>
                                </Form.Group>
                            </Form>
                            {kelengkapan.file && <div className='text-danger'>{kelengkapan.file}</div>}
                        </div>
                    </div>
                    {dataSpp &&
                        <div className='row'>
                            <div className='col-12'>
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">
                                            <Button size="sm" variant="outline-info" onClick={() => handleClickPreview(filePath)}><FaMagnifyingGlass /> Preview File</Button>
                                        </Form.Label>
                                        <Col sm="8">
                                            <Form.Label column sm="11" className="control-label align-self-center mb-0" htmlFor="searchNib">{fileNameOri}</Form.Label>
                                        </Col>
                                    </Form.Group>
                                </Form>
                                {kelengkapan.file && <div className='text-danger'>{kelengkapan.file}</div>}
                            </div>
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => handleShowConfirmSave()}>Simpan</Button>{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickBatal()}>
                        Batal
                    </Button>
                </Modal.Footer>
            </Modal>
            <PreviewPdf showOpenPreview={showOpenPreview} handleClosePreview={handleClosePreview} base64string={base64String} />
            {
                showConfirmSave &&
                <SweetAlert
                    title="Simpan Data ST Scanning?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmSave}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSaveSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data ST Berhasil"
                    onConfirm={handleClickSaveSuccess}
                    btnSize="sm"
                />
            }
            {
                showSaveFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data ST Gagal"
                    onConfirm={handleClickSaveFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

const PreviewPdf = ({ showOpenPreview, handleClosePreview, base64string }) => {
    // const pdfUrl = 'data:application/pdf;base64,' + base64string

    return (
        <>
            <Modal show={showOpenPreview} onHide={handleClosePreview} size='xl'>
                <iframe
                    src={base64string}
                    title='Preview PDF'
                    width="100%"
                    height="800px"
                ></iframe>
            </Modal>
        </>
    )
}

export default ModalSppScanning